<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('payment_type', 1) })"
    :value="value"
    :field-value.sync="payment.name"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      payment: {
        name: ''
      },
      valid: false,
      edit: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.payment =
            this.toEdit !== null ? { ...this.toEdit } : { name: '' }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          const paymenttype = !this.edit
            ? await this.$api.invoice.type.create({ form: this.payment })
            : await this.$api.invoice.type.edit({
                pk: this.payment.pk,
                form: this.payment
              })
          this.$emit('done', paymenttype.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('payment_type', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
